import { HolidayKey } from '../../types/AiForecasting';

export interface WashCopyView {
  holiday_key: HolidayKey;
  holiday_label: string;
  lead_days?: number;
  trail_days?: number;
}

function day_span(n: number, side: 'before' | 'after'): string {
  return n === 1 ? `1 day ${side}` : `${n} days ${side}`;
}

export function season_wash_subtitle(view: WashCopyView): string {
  if (view.holiday_key === 'summer') {
    return 'Summer wash is the stretch after Shavuot through the day before Tishrei. Hover any week for English and Hebrew dates.';
  }
  const lead = view.lead_days || 0;
  const trail = view.trail_days || 0;
  const after =
    trail > 0
      ? ` After the holiday it continues only through weeks where SKUs are still anomalous, up to ${day_span(trail, 'after')}. If none are, the season ends on the last holiday day.`
      : '';
  return `${view.holiday_label} wash is the calendar holiday plus ${day_span(lead, 'before')}.${after} If that would overlap the next holiday, it is cut short. The darker stripe is the holiday itself. Hover any week for English and Hebrew dates.`;
}

export function season_sku_wash_subtitle(view: WashCopyView): string {
  if (view.holiday_key === 'summer') {
    return 'This product across years. Light wash = after Shavuot through the day before Tishrei. Hover any week for English and Hebrew dates.';
  }
  const lead = view.lead_days || 0;
  const trail = view.trail_days || 0;
  const after =
    trail > 0
      ? ` After ${view.holiday_label} it continues only if this SKU’s trailing weeks are still anomalous, up to ${day_span(trail, 'after')}.`
      : '';
  return `This product across years. Light wash = ${view.holiday_label} plus ${day_span(lead, 'before')} this SKU sold or produced.${after} Darker stripe = the calendar holiday. Hover any week for English and Hebrew dates.`;
}
